import { formatDateTime, getInitials } from "../../utils";
import AssistantContent from "./AssistantContent";
import ComparisonBlock from "./ComparisonBlock";
import type { ComparisonData } from "./ComparisonBlock";
import MessageActionButtons from "./MessageActionButtons";
import MessageFeedbackAction from "./MessageFeedbackAction";
import PowerBiCard from "./PowerBiCard";
import SqlActions from "./SqlActions";
import TokenUsage from "./TokenUsage";
import { parseAssistantContent } from "./utils";

type AssistantMessageBubbleProps = {
  messageId?: string | null;
  content: string;
  sql?: string | null;
  pbiEmbed?: unknown;
  comparison?: unknown;
  tokensInput?: number;
  tokensOutput?: number;
  isStreaming?: boolean;
  onAction?: (action: string) => void;
  agentName?: string;
  createdAt?: string;
  question?: string;
};

export default function AssistantMessageBubble({
  messageId,
  content,
  sql,
  pbiEmbed,
  comparison,
  tokensInput,
  tokensOutput,
  isStreaming = false,
  onAction,
  agentName = "AI",
  createdAt,
  question,
}: AssistantMessageBubbleProps) {
  const parsedContent = parseAssistantContent(content);

  return (
    <div className="flex items-start gap-3">
      <div className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-blue-600 text-xs font-semibold text-white shadow-sm">
        {getInitials(agentName)}
      </div>
      <div className="w-full">
        <div className="rounded-2xl bg-white px-4 py-3 text-sm text-gray-800 shadow-sm ring-1 ring-gray-100">
          <AssistantContent
            content={content}
            parsedContent={parsedContent}
            isStreaming={isStreaming}
            actionsMode="hidden"
          />
          {!isStreaming && comparison != null && (
            <ComparisonBlock data={comparison as ComparisonData} />
          )}
          {!isStreaming && pbiEmbed != null && <PowerBiCard data={pbiEmbed} />}
          {!isStreaming && sql && <SqlActions sql={sql} messageId={messageId} question={question} />}
          {!isStreaming && !sql && (
            <div className="mt-2 text-xs text-gray-400">
              <MessageFeedbackAction messageId={messageId} />
            </div>
          )}
          {!isStreaming && (
            <TokenUsage
              tokensInput={tokensInput}
              tokensOutput={tokensOutput}
            />
          )}
          {!isStreaming && (
            <MessageActionButtons
              actions={parsedContent.actions}
              onAction={onAction}
            />
          )}
        </div>

        {!isStreaming && createdAt && (
          <time
            dateTime={createdAt}
            className="mt-1 block pl-1 text-[10px] text-gray-400"
          >
            {formatDateTime(createdAt)}
          </time>
        )}
      </div>
    </div>
  );
}
